var _ = require('underscore');
module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p +=
__e( prefix ) +
'' +
__e( value ) +
'' +
__e( suffix ) +
'\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./~/cartodb-deep-insights.js/src/widgets/formula/animation-template.tpl
// module id = 894
// module chunks = 2 3